import Script from "next/script"
import { getGlobals } from "storyblok/api"
import { getOfficePaths, getOffice } from "storyblok/offices"
import Meta from "components/Meta"
import LocationPageHeader from "components/Archive/LocationPageHeader"
import DynamicComponent from "components/DynamicComponent"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function Article({ story,  meta }) {


  return (
    <>
      <Meta info={meta} />
      <StoryblokVisualEditor story={story?.content}>
        <main data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="4">
          <LocationPageHeader
            blok={{
              ...story?.content,
              heading: story?.content?.name,
              address: story?.content?.address?.address,
              lat: parseFloat(story?.content?.address?.lat),
              lng: parseFloat(story?.content?.address?.lng),
              image: story?.content?.image,
              breadcrumbs: [{ text: "Locations Served", href: "/office-locations" }, { text: story?.content?.name }],
            }}
          />
          {story?.content?.body?.length
            ? story?.content?.body.map((blok) => <DynamicComponent blok={blok} key={blok._uid} />)
            : null}
        </main>
      </StoryblokVisualEditor>
      {
        story?.content?.schema?.code && 
        <Script type="application/ld+json" id="office-schema">
          {story?.content?.schema?.code}
        </Script>
      }
    
    </>
  )
}

export async function getStaticProps({ params: { location, state }, preview = null}) {
  
  const globals = await getGlobals()

  const story = await getOffice(`office-locations/${state}/${location}`, preview)

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getOfficePaths(),
    fallback: false,
  }
}
